import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function SuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect after 2 seconds
    const timer = setTimeout(() => {
      navigate("/");
    }, 2000);

    return () => clearTimeout(timer); // cleanup
  }, [navigate]);

  return (
    <div className="flex h-screen items-center justify-center bg-green-50">
      <div className="p-6 rounded-2xl shadow-lg bg-white text-center">
        <h1 className="text-2xl font-bold text-green-600 mb-2">Success!</h1>
        <p className="text-gray-600">You’ll be redirected to the homepage...</p>
      </div>
    </div>
  );
}
